app.controller('vendorTrxCtrl', ["$rootScope", "$scope", "$state", "$location", "$filter", "urlServices", "modalService", "modalFactory", "toaster", "_VAR_GLOBAL", "_API_URL","$timeout", function ($rootScope, $scope, $state, $location, $filter, urlServices, modalService, modalFactory, toaster, _VAR_GLOBAL, _API_URL, $timeout) {
    
    // --- 1. INISIALISASI DATA ---
    $scope.data = {};
    // TAMBAHKAN DUA BARIS INI AGAR DEFAULT-NYA MEMBACA <option value="">
    $scope.data.Company = ""; 
    $scope.data.KodeCabang = "";
    
    $scope.listCompany = [];
    $scope.listCategory = [];
    $scope.listDept = [];
    $scope.listCabang = [];
    $scope.detailJournal = [];
    $scope.isEdit = false;

    // Default object untuk baris baru di tabel (jika ada)
    var defaultJournal = {
        Satuan: "PCS",
        HargaSatuan: 0,
        Qty: 1,
        SubTotal: 0.00
    };

    // --- 2. LOGIKA DROPDOWN (Penerapan Baru) ---
    $scope.getCompany = function() {
        urlServices.ambilData('api/get-company', {}, function (err, sukses) {
            if (!err) {
                // Menangani wrapper sukses.data dari func.result backend
                var res = sukses.data ? sukses.data : sukses;
                $scope.listCompany = res.dt || []; 
            }
        });
    };

    $scope.getCabang = function(kodeCustomer) {
                if (!kodeCustomer) {
                    $scope.listCabang = [];
                    $scope.data.KodeCabang = ""; 
                    return;
                }

                // Paksa parameter masuk ke URL agar terbaca oleh req.query di backend
                var url = 'api/get-cabang?kodeCustomer=' + kodeCustomer;

                urlServices.ambilData(url, {}, function (err, sukses) {
                    if (!err) {
                        var res = sukses.data ? sukses.data : sukses;
                        $scope.listCabang = res.dt || [];
                        
                        // Reset pilihan cabang jika company berubah
                        $scope.data.KodeCabang = "";

                        if ($scope.listCabang.length === 1) {
                            $scope.data.KodeCabang = $scope.listCabang[0].KodeCabang;
                        }
                    }
                });
            };

    $scope.getCategory = function() {
        urlServices.ambilData('api/get-category', {}, function (err, sukses) {
            if (!err) {
                var res = sukses.data ? sukses.data : sukses;
                $scope.listCategory = res.dt || [];
            }
        });
    };

    $scope.getDept = function() {
        urlServices.ambilData('api/get-dept', {}, function (err, sukses) {
            if (!err) {
                var res = sukses.data ? sukses.data : sukses;
                $scope.listDept = res.dt || [];
            }
        });
    };

    

    // Jalankan pengisian dropdown saat controller dimuat
    $scope.getCompany();
    $scope.getCategory();
    $scope.getDept();


    $scope.isEdit = urlServices.getUrlParameter('isedit') == 'true';
    $scope.isView = urlServices.getUrlParameter('isview') == 'true';

    // FUNGSI UNTUK SET DEFAULT / RESET
        $scope.resetForm = function() {
            $scope.data = {
                Aset: 1,      // Default Tercentang
                Aktif: 1,     // Default Tercentang
                Stok: 0,      // Opsional: inisialisasi angka agar tidak null
                HargaBeli: 0,
                HargaJual: 0,
                Margin: 0
            };
            // Jika ada form validation, bisa direset di sini:
            // if($scope.frmExpenseTrx) $scope.frmExpenseTrx.$setPristine();
        };

        // JALANKAN DEFAULT HANYA JIKA TAMBAH BARU
        if (!$scope.isEdit) {
            $scope.resetForm();
        }

    if ($scope.isEdit) {
            // Ambil parameter dari URL
            var kode = urlServices.getUrlParameter('kodevendor'); 
            
            // Debugging: Munculkan di console browser untuk memastikan kodenya tertangkap
            console.log("Mengambil data untuk kode:", kode); 

            if (kode) {
                urlServices.ambilData('api/purchase-vendor/' + kode, {}, function (err, res) {
                    if (err) {
                        console.error("Error API:", err);
                        toaster.pop('error', 'Server Error', 'Gagal mengambil data dari database');
                    } else {
                        // Pastikan struktur response sesuai
                        $scope.data = res.data ? res.data : res;
                       // --- UPDATE BAGIAN INI ---

                       if ($scope.data.Customer) {
                            $scope.getCabang($scope.data.Customer);
                        }

                       // --- SOLUSI CHECKBOX ---
                        // Paksa konversi ke String "1" agar terbaca oleh ng-true-value="1"
                        // // Ini berlaku untuk View dan Edit
                        // $scope.data.Aset = ($scope.data.Aset == 1 || $scope.data.Aset == "1" || $scope.data.Aset == true) ? "1" : "0";
                        // $scope.data.Aktif = ($scope.data.Aktif == 1 || $scope.data.Aktif == "1" || $scope.data.Aktif == true) ? "1" : "0";
                        
                        $scope.kodeLama = $scope.data.KodeCustomer; // Kode asli untuk query UPDATE
                        
                        // Simpan kategori asli
                        // $scope.kategoriAsli = $scope.data.KodeItem; 
                        
                        // Simpan inisial nama asli (pakai fungsi ambilInisial)
  //                      $scope.inisialAsli = ambilInisial($scope.data.NamaBarang); 
                        
//                        console.log("Data berhasil dimuat. Kunci Asli:", $scope.kategoriAsli + "-" + $scope.inisialAsli);
    //                    console.log("Data berhasil dimuat:", $scope.data);
                       
                }
                
            });
        }
    }   
    
    function ambilInisial(nama) {
                    if (!nama) return "";
                    var n = nama.trim();
                    var words = n.split(/\s+/);
                    var res = "";
                    if (words.length >= 2) {
                        res = (words[0].substring(0, 1) + words[1].substring(0, 1)).toUpperCase();
                    } else {
                        res = (n.length >= 2 ? n.substring(0, 2) : n).toUpperCase();
                    }
                    return res;
                }
                

    $scope.saveVendor = function() {

            if ($scope.frmExpenseTrx.$invalid) {
                toaster.pop('error', "Peringatan", "Mohon lengkapi semua data yang wajib diisi!");
                return; // Berhenti di sini, jangan lanjut ke proses simpan
            }
     
            if (!$scope.data.Customer || !$scope.data.KodeCabang || !$scope.data.NamaCustomer || !$scope.data.Category || !$scope.data.Department || !$scope.data.KodeCustomer) {
                toaster.pop('warning', "Data Belum Lengkap", "Kode Vendor, Company, Cabang, Nama Vendor, Kategory dan Departemen tidak boleh kosong.");
                return;
            }
            
            var urlSave = 'api/purchase-vendor-save?isedit=' + $scope.isEdit;
                
            if($scope.isEdit) {
                    urlSave += '&kodeLama=' + $scope.kodeLama;
                }

            // Tampilkan loading (opsional)
            toaster.pop('wait', 'Proses', 'Sedang menyimpan data...');

            // 2. Kirim Data ke API
            urlServices.simpanData( urlSave , $scope.data, function (err, res) {
                if (err) {
                    // JIKA GAGAL: Tampilkan pesan error dari backend
                    toaster.pop('error', 'Gagal Simpan', err);
                } else {
                    // JIKA BERHASIL: Tampilkan pesan sukses
                    toaster.pop('success', 'Berhasil', 'Data barang berhasil ' + ($scope.isEdit ? 'diperbarui' : 'disimpan'));
                    var finalCode = (res && res.finalCode) ? res.finalCode : (res.data ? res.data.finalCode : null);

                   var finalCode = (res && res.finalCode) ? res.finalCode : (res.data ? res.data.finalCode : null);

                    if (finalCode) {
                        // Update tampilan di HTML secara instant
                        $scope.data.KodeCustomer = finalCode;
                        toaster.pop('success', 'Berhasil', 'Data disimpan dengan Kode: ' + finalCode);
                    } else {
                        toaster.pop('success', 'Berhasil', 'Data berhasil disimpan');
                    }

                    // Kasih jeda 1.5 detik supaya user bisa baca pop-up sukses baru pindah halaman
                    setTimeout(function() {
                        window.location = _API_URL + 'purchase-vendor';
                    }, 1500); 
                }
            });
        };
            
var searchTimeout; 
$scope.generateVendorCode = function() {
    // 1. Cek Kategori & Nama
    if (!$scope.data.Category || $scope.data.Category === 'TRANSPORTATION' || !$scope.data.NamaCustomer) {
        // Kalau manual (TRANSPORTATION), kosongin aja biar user isi sendiri
        if($scope.data.Category === 'TRANSPORTATION') $scope.data.KodeCustomer = "";
        return;
    }

    // Jika TRANSPORTATION, jangan panggil API generate.
    if ($scope.data.Category === 'TRANSPORTATION') {
        // Biarkan kosong jika tambah baru, atau tetap jika sedang edit
        if(!$scope.isEdit) $scope.data.KodeCustomer = ""; 
        return;
    }

    var cleanName = $scope.data.NamaCustomer.replace(/[^a-zA-Z\s]/g, '').trim();
    
    // 2. Debounce (Jeda ngetik)
    if (searchTimeout) $timeout.cancel(searchTimeout);

    searchTimeout = $timeout(function() {
        var words = cleanName.split(/\s+/).filter(function(w) { return w.length > 0; });
        var prefix = "";

        if (words.length === 1) {
            prefix = words[0].substring(0, 3);
        } else if (words.length === 2) {
            prefix = words[0].substring(0, 2) + words[1].substring(0, 1);
        } else if (words.length >= 3) {
            prefix = words[0].substring(0, 1) + words[1].substring(0, 1) + words[2].substring(0, 1);
        }

        if (prefix.length < 3) return;

        var initialCode = "SUP-" + prefix.toUpperCase();
        console.log("Mengecek kode ke API:", initialCode);
        //$scope.data.KodeCustomer = "TEST-123";

        urlServices.ambilData('api/purchase-vendor-check?kode=' + initialCode + '&nama=' + cleanName, {}, function (err, res) {
                    if (err) {
                        console.error("Gagal ambil data:", err);
                        return;
                    }

                    // DEBUG: Penting! Lihat di console browser, apakah log ini muncul?
                    console.log("Response dari API:", res);

                    // Ambil data dari wrapper
                    // Biasanya: res.data (jika langsung dari $http) atau res (jika sudah diolah service)
                    var responseData = res.data ? res.data : res;
                    
                    // Cari finalCode di dalam object (cek res.data.data.finalCode atau res.data.finalCode)
                    var final = "";
                    if (responseData.data && responseData.data.finalCode) {
                        final = responseData.data.finalCode;
                    } else if (responseData.finalCode) {
                        final = responseData.finalCode;
                    }

                    if (final) {
                        $timeout(function() {
                            $scope.data.KodeCustomer = final;
                            console.log("HTML Update Berhasil:", $scope.data.KodeCustomer);
                        }, 0);
                    } else {
                        console.log("Data finalCode tidak ditemukan di object response");
                    }
                });
    }, 800); 
};

}]);